import React, { useRef, useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createSale, getSales, voidSale,
  updateSale, addPayment, getSalePayments
} from '../../redux/features/sales/saleSlice';
import { getProducts } from '../../redux/features/product/productSlice';
import { getProductBatches } from '../../redux/features/product/productBatchSlice';
import { getCustomers } from '../../redux/features/sales/customerSlice';
import { getallAttributes } from '../../redux/features/product/attributeSlice';
import { useTable, usePagination, useGlobalFilter, useFilters, useColumnOrder } from 'react-table';
import { GlobalFilter } from '../globalFilter';
import { useRedirectLogOutUser } from "../../customHook/useRedirectLogOutUser";
import { MdOutlineCancel, MdPayment, MdReceipt, MdEditSquare, MdAssignmentReturn  } from 'react-icons/md';
import { AiOutlinePlus } from "react-icons/ai";
import ButtonLoading from '../../loader/ButtonLoader';
import { SelectColumnFilter, multiSelectFilter } from './dashBoard/SelectColumnFilter1';
import { Modal } from "bootstrap";
import Select from "react-select";
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import { ColumnToggle } from './ColumnToggle'; // ✅ from Sales1
import { applyWastage, calcBuyOptions } from '../../utils/ceramicCalculator'; // ✅ new utility functions
import { getBoxInfo } from '../../utils/boxInfo'; // ✅ universal box breakdown calculator
import { EthiopianDateCell } from './EthiopianDateCell';
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { SimpleDualDateInput } from '../DualDateInput';


const TAB_KEY = "sale_open_tab";

const formatDate = (d) => d
  ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
  : '';

const emptyItem = {
  product:       null,
  batches:       [],      // ✅ array of FIFO batches (may span multiple)
  quantity:      "",      // in native unit (m², ml, or pcs)
  quantityPcs:   0,       // computed pieces — what actually gets deducted
  sellingPrice:  "",
  targetQty:     "",      // customer's raw input (before wastage)
  wastage:       "",      // wastage percentage
  itemNote:      "",
};

const initialSaleForm = {
  paymentMethod: "cash",
  paidAmount:    "",
  customer:      null,
  customerName:  "",
  note:          "",
  date: "",
};

const dash = (v) => (v === null || v === undefined || v === "") ? "—" : v;

// ─── Receipt Component ────────────────────────────────────────
const ReceiptContent = React.forwardRef(({ sale, size }, ref) => {
  if (!sale) return null;
  const isSmall = size === "thermal";
  return (
    <div ref={ref} style={{
      fontFamily: "'Inter', sans-serif",
      padding:    isSmall ? "8px"  : "24px",
      width:      isSmall ? "72mm" : "100%",
      fontSize:   isSmall ? "10px" : "13px",
    }}>
      <div style={{ textAlign: "center", marginBottom: "12px", borderBottom: "1px dashed #ccc", paddingBottom: "8px" }}>
        <p style={{ fontWeight: 700, fontSize: isSmall ? "13px" : "18px", margin: 0 }}>Megertu Ceramic Store Inventory</p>
        <p style={{ margin: "2px 0", color: "#666" }}>{new Date(sale.createdAt).toLocaleString()}</p>
      </div>
      <div style={{ marginBottom: "8px" }}>
        <p style={{ margin: 0 }}>
          <strong>Customer:</strong>{" "}
          {sale.customer?.name || sale.customerName || "Walk-in"}
        </p>
        {(sale.customer?.tinNumber || sale.tinNumber) && (
          <p style={{ margin: 0 }}>
            <strong>TIN:</strong> {sale.customer?.tinNumber || sale.tinNumber}
          </p>
        )}
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "8px" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid #ccc" }}>
            <th style={{ textAlign: "left",   padding: "2px 0" }}>Item</th>
            <th style={{ textAlign: "center", padding: "2px 4px" }}>Qty</th>
            <th style={{ textAlign: "right",  padding: "2px 0" }}>Price</th>
            <th style={{ textAlign: "right",  padding: "2px 0" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {sale.items?.map((item, i) => {
            console.log("Calculating box info for item:", item);
            const prod   = item.product;
            const unit   = prod?.category?.measurementUnit || "pcs";
            const isBoxed = !!(prod?.itemsPerBox);
            const pcs    = item.quantity; // stored as pieces in DB
            const displayQty = item.displayQty || item.quantity;

            const boxInfo = getBoxInfo(displayQty, prod);
   
            return (
              <React.Fragment key={i}>
                <tr style={{ borderBottom: "1px dotted #eee" }}>
                  <td style={{ padding: "3px 0" }}>
                    {prod?.name || "—"}
                    {item.itemNote && (
                      <span style={{ display: "block", fontSize: "0.85em",
                                    color: "#888", fontStyle: "italic" }}>
                        ↳ {item.itemNote}
                      </span>
                    )}
                  </td>
                  <td style={{ textAlign: "center", padding: "3px 4px" }}>
                    {boxInfo ? (boxInfo.sizeLabel) : `${displayQty} ${unit}`}
                      {boxInfo && (
                        <span style={{ display: "block", fontSize: "0.82em", color: "#555" }}>
                          {boxInfo.boxLabel}
                        </span>
                      )}
                  </td>
                  <td style={{ textAlign: "right", padding: "3px 0" }}>
                    {item.sellingPrice?.toLocaleString()}
                  </td>
                  <td style={{ textAlign: "right", padding: "3px 0", fontWeight: 600 }}>
                    {item.totalPrice?.toLocaleString()}
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div style={{ borderTop: "1px solid #ccc", paddingTop: "6px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, fontSize: isSmall ? "12px" : "15px" }}>
          <span>TOTAL</span>
          <span>{sale.totalAmount?.toLocaleString()} birr</span>
        </div>
        {sale.paidAmount > 0 && sale.unpaidAmount > 0 && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", color: "#198754" }}>
              <span>PAID</span>
              <span>{sale.paidAmount?.toLocaleString()} birr</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", color: "#dc3545", fontWeight: 700 }}>
              <span>REMAINING</span>
              <span>{sale.unpaidAmount?.toLocaleString()} birr</span>
            </div>
          </>
        )}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "4px" }}>
          <span>Payment</span>
          <span>{sale.paymentMethod}</span>
        </div>
      </div>
      {sale.note && (
        <p style={{ marginTop: "8px", borderTop: "1px dashed #ccc", paddingTop: "6px", color: "#555" }}>
          Note: {sale.note}
        </p>
      )}
      <p style={{ textAlign: "center", marginTop: "12px", color: "#888", fontSize: isSmall ? "9px" : "11px" }}>
        Thank you for your purchase!
      </p>
    </div>
  );
});

export const Sales = () => {
  useRedirectLogOutUser();
  const dispatch = useDispatch();

  // ── Separate refs for table print vs receipt print ────────
  const tablePrintRef  = useRef();
  const receiptRef     = useRef();
  const navigate       = useNavigate();

  const saleModalRef    = useRef(null);
  const editModalRef    = useRef(null);
  const voidModalRef    = useRef(null);
  const paymentModalRef = useRef(null);
  const receiptModalRef = useRef(null);

  const [tabItems, setTabItems] = useState(() => {
    try {
      const saved = localStorage.getItem(TAB_KEY);
      return saved ? JSON.parse(saved) : [{ ...emptyItem }];
    } catch { return [{ ...emptyItem }]; }
  });

  const [saleForm, setSaleForm]         = useState(initialSaleForm);
  const [editForm, setEditForm]         = useState(initialSaleForm);
  const [isLoading, setIsLoading]       = useState(false);
  const [voidId, setVoidId]             = useState(null);
  const [voidReason, setVoidReason]     = useState("");
  const [editSale, setEditSale]         = useState(null);
  const [selectedSale, setSelectedSale] = useState(null);
  const [paymentData, setPaymentData]   = useState({ amount: "", paymentMethod: "cash", note: "" });
  const [printView, setPrintView]       = useState(false);
  const [receiptSize, setReceiptSize]   = useState("a4");

  const { sales }          = useSelector((state) => state.sale);
  const { products }       = useSelector((state) => state.product);
  const { productBatches } = useSelector((state) => state.productBatch);
  const { customers }      = useSelector((state) => state.customer);
  const { userType }       = useSelector((state) => state.auth);
  const { attributes }     = useSelector((state) => state.attribute);
  const isAdmin            = userType === "admin";

  console.log("sales", sales);
  useEffect(() => {
    localStorage.setItem(TAB_KEY, JSON.stringify(tabItems));
  }, [tabItems]);

  const hasFetched = useRef(false);
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    dispatch(getSales());
    dispatch(getProducts());
    dispatch(getProductBatches());
    dispatch(getCustomers());
    dispatch(getallAttributes());
  }, [dispatch]);

  // ── Options ────────────────────────────────────────────────
  const productOptions = useMemo(() =>
    products.map(p => ({ value: p._id, label: `${p.name} (${p.sku})` })),
  [products]);

  const customerOptions = useMemo(() =>
    customers.map(c => ({ value: c._id, label: `${c.name}${c.phone ? ` — ${c.phone}` : ""}` })),
  [customers]);

  // ── FIFO: oldest batch with stock ──────────────────────────
  const getLatestBatchFor = useCallback((productId) => {
    const batches = productBatches
      .filter(b => {
        const bProdId = b.product?._id || b.product;
        return bProdId === productId && b.remainingQuantity > 0;
      })
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    return batches[0] || null;
  }, [productBatches]);

  const resolveFifoBatches = useCallback((productId, piecesNeeded) => {
    const sorted = productBatches
      .filter(b => {
        const id = b.product?._id || b.product;
        return id === productId && b.remainingQuantity > 0;
      })
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

    const result   = [];
    let   remaining = piecesNeeded;

    for (const batch of sorted) {
      if (remaining <= 0) break;
      const take = Math.min(batch.remainingQuantity, remaining);
      result.push({
        batchId:   batch._id,
        label:     `Batch ${new Date(batch.createdAt).toLocaleDateString()} — ${batch.remainingQuantity} in stock`,
        take,
        price:     batch.sellingPrice,
      });
      remaining -= take;
    }

    return { batches: result, canFulfill: remaining <= 0 };
  }, [productBatches]);

  // ── Tab item handlers ──────────────────────────────────────
  const addTabItem = () => setTabItems(prev => [...prev, { ...emptyItem }]);

  const removeTabItem = (index) =>
    setTabItems(prev => prev.filter((_, i) => i !== index));

  const updateTabItem = (index, field, value) => {
    setTabItems(prev => prev.map((item, i) => {
      if (i !== index) return item;

      // ── Product selection ──────────────────────────────────
      if (field === "product") {
        if (!value) return { ...emptyItem };
        const productDoc = products.find(p => p._id === value.value);
        const { batches } = resolveFifoBatches(value.value, 1);
        return {
          ...emptyItem,
          product:      value,
          batches,
          sellingPrice: productDoc?.sellingPriceRange?.minSellingPrice
           || productDoc?.sellingPrice  // ✅ fallback for old docs
           || "",
        };
      }

      // ── Target quantity entered by staff ───────────────────
      if (field === "targetQty" || field === "wastage") {
        const productDoc   = products.find(p => p._id === item.product?.value);
        const unit         = productDoc?.category?.measurementUnit || "pcs";
        const isBoxed      = !!(productDoc?.itemsPerBox);

        const target  = field === "targetQty" ? Number(value)       : Number(item.targetQty);
        const wastage = field === "wastage"   ? Number(value)       : Number(item.wastage);
        const adjusted = applyWastage(target, wastage);

        const options = isBoxed || productDoc?.sizePerItem
          ? calcBuyOptions(adjusted, productDoc, unit)
          : null;

        // Auto-select the higher option
        const chosen   = options?.up;
        const piecesUp = chosen?.pieces || (unit === "pcs" ? Math.ceil(adjusted) : 0);

        // Resolve FIFO batches for the chosen piece count
        const { batches, canFulfill } = resolveFifoBatches(item.product?.value, piecesUp);
        if (piecesUp > 0 && !canFulfill) {
          toast.warning("Not enough stock across all batches for the higher option");
        }

        return {
          ...item,
          [field]:     value,
          quantity:    chosen ? chosen.quantityValue : (unit === "pcs" ? piecesUp : ""),
          quantityPcs: piecesUp,
          batches,
          _options:    options,  // stash for rendering
        };
      }

      // ── Manual quantity edit ───────────────────────────────
      if (field === "quantity") {
        const productDoc = products.find(p => p._id === item.product?.value);
        const unit       = productDoc?.category?.measurementUnit || "pcs";
        const pcs = unit === "pcs"
          ? Math.ceil(Number(value))
          : productDoc?.sizePerItem
            ? Math.ceil(Number(value) / productDoc.sizePerItem)
            : Math.ceil(Number(value));
        const { batches } = resolveFifoBatches(item.product?.value, pcs);
        return { ...item, quantity: value, quantityPcs: pcs, batches };
      }

      return { ...item, [field]: value };
    }));
  };

  // ── Totals ─────────────────────────────────────────────────
  const totalAmount = useMemo(() =>
    tabItems.reduce((sum, item) =>
      sum + ((Number(item.quantity) || 0) * (Number(item.sellingPrice) || 0)), 0),
  [tabItems]);

  const unpaidAmount = useMemo(() => {
    if (saleForm.paymentMethod === "cash" || saleForm.paymentMethod === "bank") return 0;
    return Math.max(0, totalAmount - (Number(saleForm.paidAmount) || 0));
  }, [totalAmount, saleForm.paidAmount, saleForm.paymentMethod]);

  const paymentStatus = useMemo(() => {
    if (saleForm.paymentMethod === "cash" || saleForm.paymentMethod === "bank") return "paid";
    const paid = Number(saleForm.paidAmount) || 0;
    if (paid <= 0)           return "unpaid";
    if (paid >= totalAmount) return "paid";
    return "partial";
  }, [saleForm.paidAmount, totalAmount, saleForm.paymentMethod]);

  // ── Modal openers ──────────────────────────────────────────
  const openSaleModal = () => {
    document.activeElement?.blur();
    new Modal(saleModalRef.current).show();
  };

  const openEditModal = (sale) => {
    setEditSale(sale);
    setEditForm({
      paymentMethod: sale.paymentMethod || "cash",
      paidAmount:    sale.paidAmount    || "",
      customer:      sale.customer
        ? { value: sale.customer._id, label: `${sale.customer.name}` }
        : null,
      customerName: sale.customerName || "",
      note:         sale.note         || "",
      date:         sale.createdAt   ? sale.createdAt : "",
    });
    document.activeElement?.blur();
    new Modal(editModalRef.current).show();
  };

  const openVoidModal = (id) => {
    setVoidId(id);
    setVoidReason("");
    document.activeElement?.blur();
    new Modal(voidModalRef.current).show();
  };

  const openPaymentModal = (sale) => {
    setSelectedSale(sale);
    setPaymentData({ amount: "", paymentMethod: "cash", note: "" });
    dispatch(getSalePayments(sale._id));
    document.activeElement?.blur();
    new Modal(paymentModalRef.current).show();
  };

  const openReceiptModal = (sale) => {
    setSelectedSale(sale);
    document.activeElement?.blur();
    new Modal(receiptModalRef.current).show();
  };

  // ── Submit sale ────────────────────────────────────────────
  const handleSubmitSale = async (e) => {
    e.preventDefault();
    const validItems = tabItems.filter(i => i.product && i.quantity && i.sellingPrice);
    if (validItems.length === 0) {
      return toast.error("Please add at least one complete item");
    }
    const isFull = saleForm.paymentMethod === "cash" || saleForm.paymentMethod === "bank";
    const paid   = isFull ? totalAmount : (Number(saleForm.paidAmount) || 0);

    if (!isFull && !saleForm.customer && !saleForm.customerName.trim()) {
      return toast.error("For credit or partial payments, please enter customer details");
    }

    if (paid > totalAmount) {
      return toast.error("Paid amount cannot exceed total amount");
    }

    setIsLoading(true);
    const result = await dispatch(createSale({
      items: validItems.map(i => ({
        product:      i.product.value,
        quantity:     Number(i.quantity), // pieces for FIFO deduction
        displayQty:   Number(i.quantity),   // m², ml, or pcs for display
        sellingPrice: Number(i.sellingPrice),
        totalPrice:   Number(i.quantity) * Number(i.sellingPrice),
        itemNote:     i.itemNote || null,
      })),
      totalAmount,
      paymentMethod: saleForm.paymentMethod,
      paidAmount:    paid,
      customer:      saleForm.customer?.value || null,
      customerName:  saleForm.customerName    || "",
      note:          saleForm.note            || "",
      date:          saleForm.date            || null,
    }));
    setIsLoading(false);

    if (!result.error) {
      setTabItems([{ ...emptyItem }]);
      localStorage.removeItem(TAB_KEY);
      setSaleForm(initialSaleForm);
      Modal.getInstance(saleModalRef.current).hide();
      dispatch(getSales());
    }
  };

  // ── Edit submit ────────────────────────────────────────────
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const isFull = editForm.paymentMethod === "cash" || editForm.paymentMethod === "bank";
    const paid   = isFull ? editSale.totalAmount : (Number(editForm.paidAmount) || 0);
    await dispatch(updateSale({
      id: editSale._id,
      data: {
        note:          editForm.note,
        customerName:  editForm.customerName,
        customer:      editForm.customer?.value || null,
        paymentMethod: editForm.paymentMethod,
        paidAmount:    paid,
      }
    }));
    Modal.getInstance(editModalRef.current).hide();
  };

  // ── Void sale ──────────────────────────────────────────────
  const handleVoidSale = async () => {
    if (!voidReason.trim()) return toast.error("Please provide a void reason");
    setIsLoading(true);
    await dispatch(voidSale({ id: voidId, voidReason }));
    setIsLoading(false);
    Modal.getInstance(voidModalRef.current).hide();
    dispatch(getSales());
  };

  // ── Add payment ────────────────────────────────────────────
  const handleAddPayment = async (e) => {
    e.preventDefault();
    if (!paymentData.amount) return toast.error("Enter payment amount");
    setIsLoading(true);
    await dispatch(addPayment({ saleId: selectedSale._id, data: paymentData }));
    setIsLoading(false);
    setPaymentData({ amount: "", paymentMethod: "cash", note: "" });
    dispatch(getSales());
  };

  const handlePrint = () => setPrintView(true);
  const handleBeforeGetContent = async () => await setPrintView(true);

  const selectStyles = {
    control: (base) => ({ ...base, minHeight: "46px", fontSize: "1.5rem" }),
    menu:    (base) => ({ ...base, zIndex: 9999, fontSize: "1.75rem" }),
  };

  const paymentMethodOptions = [
    { value: "cash",    label: "Cash" },
    { value: "bank",    label: "Bank" },
    { value: "credit",  label: "Credit" },
    { value: "partial", label: "Partial" },
  ];

  // ── Table columns ──────────────────────────────────────────
  const columns = useMemo(() => {
    const base = [
      { Header: 'No', id: 'no', Cell: ({ row }) => row.index + 1 },
      {
        Header: 'Product Name',
        accessor: '_productNames',
        Filter: SelectColumnFilter,
        filter: 'multiSelectFilter',
        Cell: ({ row }) => (
          <div className="d-flex flex-wrap gap-1">
            {row.original.items?.map((item, i) => (
              <span key={i}
                className="badge bg-primary bg-opacity-10 text-primary
                          rounded-pill px-2 py-1 fs-4">
                {item.product?.name || "—"}
              </span>
            ))}
          </div>
        )
      },
      {
        Header: 'SKU',
        accessor: '_productSkus',
        Filter: SelectColumnFilter,
        filter: 'multiSelectFilter',
        Cell: ({ row }) => (
          <div className="d-flex flex-wrap gap-1">
            {row.original.items?.map((item, i) => (
              <span key={i}
                className="badge bg-secondary bg-opacity-10 text-secondary
                          rounded-pill px-2 py-1 fs-4">
                {item.product?.sku || "—"}
              </span>
            ))}
          </div>
        )
      },
      {
        Header: 'Qty',
        accessor: '_itemsLabel',
        Cell: ({ row }) => (
          <div className="d-flex flex-wrap gap-1">
            {row.original.items?.map((item, i) => {
              const unit = item.product?.category?.measurementUnit || "pcs";
              const label = unit === "m2" ? "m²"
                : unit === "linear_meter" ? "m" : "pcs";
              return (
                <span key={i}
                  className="badge bg-info bg-opacity-10 text-info
                            rounded-pill px-2 py-1 fs-4">
                  {item.quantity} {label}
                </span>
              );
            })}
          </div>
        )
      },
      {
        Header: 'Selling Price', 
        accessor: '_productsellingPrice',
        Cell: ({ value }) => value || "—"
      },
      {
        Header: 'Total', accessor: 'totalAmount',
        Cell: ({ value }) => value != null ? `${value.toLocaleString()} birr` : "—"
      },
      {
        Header: 'Paid', accessor: 'paidAmount',
        Cell: ({ value }) => value != null ? `${value.toLocaleString()} birr` : "—"
      },
      {
        Header: 'Unpaid', accessor: 'unpaidAmount',
        Cell: ({ value }) => value > 0
          ? <span className="text-danger fw-semibold">{value.toLocaleString()} birr</span>
          : <span className="text-success">—</span>
      },
      ...(isAdmin ? [{
        Header: 'Profit',
        id: 'profit',
        accessor: row => row.items,
        Cell: ({ value }) => {
          const totalProfit = Array.isArray(value)
            ? value.reduce((sum, item) => sum + (item.profit || 0), 0)
            : 0;
          return totalProfit > 0
            ? <span className="text-success fw-semibold">{totalProfit.toLocaleString()} birr</span>
            : <span className="text-muted">—</span>;
        }
      }] : []),
      {
        Header: 'Status', accessor: 'paymentStatus',
        Filter: SelectColumnFilter, filter: 'multiSelectFilter',
        Cell: ({ value }) => {
          const colors = { paid: 'success', partial: 'warning', unpaid: 'danger' };
          return (
            <span className={`badge bg-${colors[value] || 'secondary'} rounded-pill px-3 py-2 fs-6`}>
              {value || "—"}
            </span>
          );
        }
      },
      {
        Header: 'Payment', accessor: 'paymentMethod',
        Filter: SelectColumnFilter, filter: 'multiSelectFilter',
        Cell: ({ value }) => dash(value)
      },
      {
        Header: 'Customer', accessor: 'customer.name',
        Filter: SelectColumnFilter, filter: 'multiSelectFilter',
        Cell: ({ value, row }) => dash(value || row.original.customerName)
      },
      {
        Header: 'Note', accessor: 'note',
        Cell: ({ value }) => dash(value)
      },
      {
        Header: 'Voided', accessor: 'isVoided',
        Cell: ({ value, row }) => value
          ? <span className="badge bg-danger rounded-pill px-2 py-1" title={row.original.voidReason}>Voided</span>
          : <span className="text-success">Active</span>
      },
      {
        Header: 'Added By', accessor: 'addedBy.firstname',
        Filter: SelectColumnFilter, filter: 'multiSelectFilter',
        Cell: ({ value }) => dash(value)
      },
      {
        Header: 'Date', accessor: 'createdAt',
        Filter: SelectColumnFilter, filter: 'multiSelectFilter',
        Cell: ({ value }) => value ? <EthiopianDateCell value={value} dual time /> : "—"
      },
    ];
 
    if (!printView) {
      base.push({
        Header: 'Action',
        id: 'action',
        Cell: ({ row }) => (
          <div className="d-flex gap-1">
            <span className="text-info" style={{ cursor: 'pointer', padding: '5px' }}
              onClick={() => openReceiptModal(row.original)} title="View receipt">
              <MdReceipt size={22} />
            </span>
            {isAdmin && !row.original.isVoided && (
              <>
              <span className="text-warning" style={{ cursor: 'pointer', padding: '5px' }}
                onClick={() => openEditModal(row.original)} title="Edit sale">
                <MdEditSquare size={22} />
              </span>
               <span className="text-warning"
                  style={{ cursor: "pointer", padding: "5px" }}
                  onClick={() => navigate("/sale-returns",
                    { state: { sale: row.original } })}
                  title="Process return">
                  <MdAssignmentReturn size={22} />
                </span>
              </>
            )}
            {row.original.paymentStatus !== 'paid' && !row.original.isVoided && isAdmin && (
              <span className="text-success" style={{ cursor: 'pointer', padding: '5px' }}
                onClick={() => openPaymentModal(row.original)} title="Add payment">
                <MdPayment size={22} />
              </span>
            )}
            {isAdmin && !row.original.isVoided && (
              <span className="text-danger" style={{ cursor: 'pointer', padding: '5px' }}
                onClick={() => openVoidModal(row.original._id)} title="Void sale">
                <MdOutlineCancel size={22} />
              </span>
            )}
          </div>
        )
      });
    }
 
    return base;
  }, [printView, isAdmin]);
 
  const data = useMemo(() =>
  Array.isArray(sales) ? sales.map(sale => {
    // ✅ Extract filterable fields from items array
    const productNames = sale.items?.map(i =>
      i.product?.name || "—").join(", ") || "";
    const productSkus  = sale.items?.map(i =>
      i.product?.sku  || "—").join(", ") || "";
    const itemsLabel   = sale.items?.map(i =>
      `${i.product?.name} × ${i.quantity} ${
        i.product?.category?.measurementUnit || ""
      }`).join(" | ") || "";
    const productsellingPrice = sale.items?.map(i =>
      i.sellingPrice).join(", ") || "";

    return {
      ...sale,
      _productNames: productNames, // ✅ flat string for filter
      _productSkus:  productSkus,
      _itemsLabel:   itemsLabel,
      _productsellingPrice: productsellingPrice,
    };
  }) : [],
[sales]);
  const filterTypes = useMemo(() => ({ multiSelectFilter }), []);

  const tableInstance = useTable({
    columns, data, filterTypes,
    defaultColumn: { Filter: () => null },
    initialState: { hiddenColumns: ['note', 'addedBy.firstname', 'isVoided'] }
  }, useFilters, useGlobalFilter, useColumnOrder, usePagination);

  const {
    getTableProps, getTableBodyProps, headerGroups, page,
    nextPage, previousPage, canNextPage, canPreviousPage,
    gotoPage, pageCount, setGlobalFilter, pageOptions,
    setPageSize, state, prepareRow,
    allColumns, getToggleHideAllColumnsProps,
  } = tableInstance;

  const { pageIndex, globalFilter, pageSize } = state;

  return (
    <div>

      {/* ── SALE MODAL ────────────────────────────────────────── */}
      <div className="modal fade modal-dialog-scrollable" ref={saleModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content border-0 rounded-4 shadow-lg p-2">

            <div className="modal-header pb-3">
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#e7f1ff" }}>
                  <AiOutlinePlus color="#0d6efd" size={28} />
                </div>
                <div>
                  <h3 className="modal-title fw-semibold mb-1">New Sale</h3>
                  <small className="text-muted fs-5">
                    Items saved to tab — add more anytime.
                  </small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>

            <form onSubmit={handleSubmitSale} className="border-0">
              <div className="modal-body py-3">
                <div className="bg-light rounded-3 px-3 py-3">
                  <div className="row g-3">

                    {tabItems.map((item, index) => {
                      const productDoc  = products.find(p => p._id === item.product?.value);
                      const unit        = productDoc?.category?.measurementUnit || "pcs";
                      const isBoxed     = !!(productDoc?.itemsPerBox);
                      const hasSize     = !!(productDoc?.sizePerItem);
                      const showCalc    = isBoxed || hasSize;
                      const options     = item._options || null;

                      return (
                        <div key={index} className="col-12">
                          <div className="border rounded-3 px-3 py-3 bg-white">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="fw-semibold fs-4">Item {index + 1}</span>
                                {tabItems.length > 1 && (
                                            <button type="button"
                                              className="btn btn-sm btn-outline-danger rounded-3"
                                              onClick={() => removeTabItem(index)}>Remove</button>
                                          )}
                                        </div>
                                        <div className="row g-2">

                                          {/* Product */}
                                          <div className={`col-12 ${showCalc ? 'col-md-6' : 'col-md-6'}`}>
                                            <label className="form-label fw-medium mb-1 fs-4">Product</label>
                                            <Select
                                              options={productOptions}
                                              value={item.product}
                                              onChange={(v) => updateTabItem(index, "product", v)}
                                              placeholder="Select product..."
                                              isClearable isSearchable
                                              styles={selectStyles}
                                            />
                                          </div>

                                          {/* FIFO Batch(es) — auto, disabled, shows multi-batch if needed */}
                                          <div className="col-12 col-md-6">
                                            <label className="form-label fw-medium mb-1 fs-4">
                                              Batch (FIFO auto)
                                              {item.batches?.length > 1 && (
                                                <span className="badge bg-warning bg-opacity-25 text-warning ms-2 fs-5">
                                                  spans {item.batches.length} batches
                                                </span>
                                              )}
                                            </label>
                                            {item.batches?.length > 0 ? (
                                              <div className="d-flex flex-column gap-1">
                                                {item.batches.map((b, bi) => (
                                                  <div key={bi}
                                                    className="form-control border-2 bg-light fs-5 py-1 px-2"
                                                    style={{ cursor: "not-allowed", color: "#6c757d", fontSize: "0.95rem" }}>
                                                    {b.label}
                                                    {item.batches.length > 1 && (
                                                      <span className="ms-2 fw-semibold text-dark">→ {b.take} pcs</span>
                                                    )}
                                                  </div>
                                                ))}
                                              </div>
                                            ) : (
                                              <div className="form-control bg-light border-2 text-muted fs-4"
                                                style={{ cursor: "not-allowed" }}>
                                                {item.product ? "No stock available" : "Select a product first"}
                                              </div>
                                            )}
                                          </div>

                                          {/* ── Calculator — for boxed / sized products ── */}
                                          {showCalc && (
                                            <div className="col-12">
                                              <div className="border rounded-3 px-3 py-3 bg-light">
                                                <p className="fw-semibold fs-4 mb-2 border-bottom pb-1">
                                                  Quantity Calculator
                                                </p>
                                                <div className="row g-2">

                                                  {/* Customer requirement input */}
                                                  <div className="col-6 col-md-4">
                                                    <label className="form-label fw-medium mb-1 fs-4">
                                                      Customer Needs ({unit === "m2" ? "m²" : unit === "ml" ? "meters" : "pcs"})
                                                    </label>
                                                    <div className="input-group input-group-lg">
                                                      <input
                                                        className="form-control border-2 fs-4"
                                                        type="number" min="0" step="0.01"
                                                        placeholder={unit === "m2" ? "e.g. 11" : unit === "ml" ? "e.g. 10" : "e.g. 6"}
                                                        value={item.targetQty}
                                                        onChange={(e) => updateTabItem(index, "targetQty", e.target.value)}
                                                      />
                                                      <span className="input-group-text fs-5">
                                                        {unit === "m2" ? "m²" : unit === "ml" ? "m" : "pcs"}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  {/* Wastage % */}
                                                  <div className="col-6 col-md-2">
                                                    <label className="form-label fw-medium mb-1 fs-4">
                                                      Wastage %
                                                    </label>
                                                    <input
                                                      className="form-control form-control-lg border-2 fs-4"
                                                      type="number" min="0" max="50" step="1"
                                                      placeholder="0"
                                                      value={item.wastage}
                                                      onChange={(e) => updateTabItem(index, "wastage", e.target.value)}
                                                    />
                                                  </div>

                                                  {/* Options — shown once targetQty is entered */}
                                                  {options && (
                                                    <div className="col-12">
                                                      <label className="form-label fw-medium mb-1 fs-4">
                                                        Sellable Options — click to select
                                                      </label>
                                                      <div className="d-flex flex-wrap gap-2">

                                                        {/* ▲ Round up — recommended */}
                                                        <button type="button"
                                                          className={`btn rounded-3 fs-5 ${
                                                            Number(item.quantity) === options.up.quantityValue
                                                              ? "btn-primary"
                                                              : "btn-outline-primary"
                                                          }`}
                                                          onClick={() => {
                                                            const { batches } = resolveFifoBatches(item.product?.value, options.up.pieces);
                                                            setTabItems(prev => prev.map((it, i) => i !== index ? it : {
                                                              ...it,
                                                              quantity:    options.up.quantityValue,
                                                              quantityPcs: options.up.pieces,
                                                              batches,
                                                              _options:    options,
                                                            }));
                                                          }}>
                                                          <span className="badge bg-success me-1 fs-6">Recommended</span>
                                                          ▲ {options.up.sizeLabel} — {options.up.pieces} pcs
                                                          {options.up.boxLabel && (
                                                            <span className="ms-1 opacity-75">({options.up.boxLabel})</span>
                                                          )}
                                                        </button>

                                                        {/* ▼ Round down — shortage risk */}
                                                        {options.down && (
                                                          <button type="button"
                                                            className={`btn rounded-3 fs-5 ${
                                                              Number(item.quantity) === options.down.quantityValue
                                                                ? "btn-warning text-dark"
                                                                : "btn-outline-warning text-dark"
                                                            }`}
                                                            onClick={() => {
                                                              const { batches } = resolveFifoBatches(item.product?.value, options.down.pieces);
                                                              setTabItems(prev => prev.map((it, i) => i !== index ? it : {
                                                                ...it,
                                                                quantity:    options.down.quantityValue,
                                                                quantityPcs: options.down.pieces,
                                                                batches,
                                                                _options:    options,
                                                              }));
                                                            }}>
                                                            <span className="badge bg-danger me-1 fs-6">Shortage risk</span>
                                                            ▼ {options.down.sizeLabel} — {options.down.pieces} pcs
                                                            {options.down.boxLabel && (
                                                              <span className="ms-1 opacity-75">({options.down.boxLabel})</span>
                                                            )}
                                                          </button>
                                                        )}

                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )}

                                          {/* Quantity — native unit, editable */}
                                          <div className="col-6 col-md-3">
                                            <label className="form-label fw-medium mb-1 fs-4">
                                              Qty ({unit === "m2" ? "m²" : unit === "ml" ? "m" : "pcs"})
                                              {item.quantityPcs > 0 && unit !== "pcs" && (
                                                <span className="text-muted ms-1 fs-5">
                                                  = {item.quantityPcs} pcs
                                                  {isBoxed && productDoc?.itemsPerBox && (
                                                    <span>
                                                      {" "}({Math.floor(item.quantityPcs / productDoc.itemsPerBox)} box
                                                      {item.quantityPcs % productDoc.itemsPerBox > 0
                                                        ? ` + ${item.quantityPcs % productDoc.itemsPerBox} pcs`
                                                        : ""})
                                                    </span>
                                                  )}
                                                </span>
                                              )}
                                            </label>
                                            <input
                                              className="form-control border-2 fs-4"
                                              type="float" min="0" step={unit === "pcs" ? "1" : "0.01"}
                                              placeholder="0"
                                              value={item.quantity}
                                              onChange={(e) => updateTabItem(index, "quantity", e.target.value)}
                                            />
                                          </div>

                                          {/* Selling Price */}
                                          <div className="col-6 col-md-3">
                                            <label className="form-label fw-medium mb-1 fs-4">
                                              Price / {unit === "m2" ? "m²" : unit === "ml" ? "m" : "pc"}
                                            </label>
                                            <input
                                              className="form-control border-2 fs-4"
                                              type="float" min="0"
                                              placeholder="0.00"
                                              value={item.sellingPrice}
                                              onChange={(e) => updateTabItem(index, "sellingPrice", e.target.value)}
                                            />
                                          </div>

                                          {/* Subtotal */}
                                          <div className="col-6 col-md-3 d-flex align-items-end">
                                            <div className="w-100">
                                              <label className="form-label fw-medium mb-1 fs-4">Subtotal</label>
                                              <input
                                                className="form-control border-2 bg-white fw-semibold fs-4"
                                                value={((Number(item.quantity)||0)*(Number(item.sellingPrice)||0)).toLocaleString()}
                                                readOnly tabIndex={-1}
                                                style={{ color: "#198754" }}
                                              />
                                            </div>
                                          </div>

                                          {/* Per-item note */}
                                          <div className="col-12">
                                            <label className="form-label fw-medium mb-1 fs-4">
                                              Item Note{" "}
                                              <span className="text-muted fs-5 fw-normal">
                                                e.g. "Bathroom", "Kitchen floor"
                                              </span>
                                            </label>
                                            <input
                                              className="form-control border-2 fs-4"
                                              type="text"
                                              placeholder="Where is this item going? (optional)"
                                              value={item.itemNote}
                                              onChange={(e) => updateTabItem(index, "itemNote", e.target.value)}
                                            />
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}

                    <div className="col-12">
                      <button type="button"
                        className="btn btn-outline-primary rounded-3 w-100 fs-4"
                        onClick={addTabItem}>
                        <AiOutlinePlus className="me-1 fs-2" /> Add Another Item
                      </button>
                    </div>

                    <div className="col-12"><hr className="my-1" /></div>
                    {/* sale Date */}
                    
                    {/* Customer */}
                    <div className="col-12 col-md-6">
                      <label className="fs-4">Customer</label>
                      <Select
                        options={customerOptions}
                        value={saleForm.customer}
                        onChange={(v) => setSaleForm(prev => ({ ...prev, customer: v || null }))}
                        placeholder="Select customer (optional)..."
                        isClearable isSearchable
                        styles={selectStyles}
                        
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="fs-4">Payment Method</label>
                      <Select
                        options={paymentMethodOptions}
                        value={paymentMethodOptions.find(o => o.value === saleForm.paymentMethod)}
                        onChange={(v) => setSaleForm(prev => ({
                          ...prev,
                          paymentMethod: v.value,
                          paidAmount: ""
                        }))}
                        styles={selectStyles}
                      />
                    </div>

                    {!saleForm.customer && (
                      <div className="col-12 col-md-6">
                        <label className="fs-4">Customer Name</label>
                        <input
                          className="form-control form-control-lg border-2"
                          placeholder="Walk-in customer name (optional)"
                          value={saleForm.customerName}
                          onChange={(e) => setSaleForm(prev => ({ ...prev, customerName: e.target.value }))}
                        />
                      </div>
                    )}

                    {/* Payment Method */}
                    

                    {/* Cash/Bank: optional amount received */}
                    {(saleForm.paymentMethod === "cash" || saleForm.paymentMethod === "bank") && (
                      <div className="col-12 col-md-6">
                        <label className="fs-4">Amount Received</label>
                        <input
                          className="form-control form-control-lg border-2 fs-4"
                          type="number" min="0"
                          placeholder={`${totalAmount.toLocaleString()} (full amount)`}
                          value={saleForm.paidAmount}
                          onChange={(e) => setSaleForm(prev => ({ ...prev, paidAmount: e.target.value }))}
                        />
                        <small className="text-muted fs-5">Leave empty to use total amount</small>
                      </div>
                    )}

                    {/* Partial/Credit: required paid amount */}
                    {(saleForm.paymentMethod === "partial" || saleForm.paymentMethod === "credit") && (
                      <div className="col-12 col-md-4">
                        <label className="fs-4">Paid Amount <span className="text-danger">*</span></label>
                        <input
                          className="form-control form-control-lg border-2"
                          type="number" min="0"
                          placeholder="0.00"
                          value={saleForm.paidAmount}
                          onChange={(e) => setSaleForm(prev => ({ ...prev, paidAmount: e.target.value }))}
                        />
                      </div>
                    )}

                    {isAdmin && (
                    <div className="col-6">
                            <SimpleDualDateInput
                              label="Sell Date"
                              value={saleForm.date}
                              onChange={(date) => setSaleForm(prev => ({ ...prev, date }))}
                              maxDate={new Date()}
                            />
                          </div>

                      )}

                    {/* Note */}
                    <div className="col-12">
                      <label className="fs-4">Note</label>
                      <textarea
                        className="form-control border-2" rows={2}
                        placeholder="Optional note..."
                        value={saleForm.note}
                        onChange={(e) => setSaleForm(prev => ({ ...prev, note: e.target.value }))}
                      />
                    </div>

                    {/* Summary */}
                    <div className="col-12">
                      <div className="d-flex flex-wrap gap-3 p-3 bg-white border rounded-3">
                        <div>
                          <p className="text-muted mb-0 fs-4">TOTAL</p>
                          <p className="fw-bold mb-0 fs-4">{totalAmount.toLocaleString()} birr</p>
                        </div>
                        {(saleForm.paymentMethod === "partial" || saleForm.paymentMethod === "credit") && (
                          <>
                            <div>
                              <p className="text-muted mb-0 fs-4">PAID</p>
                              <p className="fw-bold mb-0 fs-4 text-success">
                                {(Number(saleForm.paidAmount) || 0).toLocaleString()} birr
                              </p>
                            </div>
                            <div>
                              <p className="text-muted mb-0 fs-4">UNPAID</p>
                              <p className="fw-bold mb-0 fs-4 text-danger">
                                {unpaidAmount.toLocaleString()} birr
                              </p>
                            </div>
                          </>
                        )}
                        <div>
                          <p className="text-muted mb-0 fs-4">STATUS</p>
                          <span className={`badge rounded-pill px-3 py-2 fs-4 bg-${
                            paymentStatus === "paid"    ? "success" :
                            paymentStatus === "partial" ? "warning" : "danger"
                          }`}>{paymentStatus}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="modal-footer border-0 pt-0 gap-2">
                <button type="button"
                  className="btn btn-danger border flex-fill rounded-3 fw-medium py-2 fs-2"
                  data-bs-dismiss="modal">Close</button>
                {isLoading ? (
                  <ButtonLoading className="btn btn-primary flex-fill rounded-3 fw-medium py-2" fs-2 disabled>
                    Processing...
                  </ButtonLoading>
                ) : (
                  <button type="submit"
                    className="btn btn-primary flex-fill rounded-3 fw-medium py-2 fs-2">
                    Confirm Sale
                  </button>
                )}
              </div>
            </form>

          </div>
        </div>
      </div>

      {/* ── EDIT MODAL ────────────────────────────────────────── */}
      <div className="modal fade" ref={editModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content border-0 rounded-4 shadow-lg p-2">

            <div className="modal-header pb-3">
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#e7f1ff" }}>
                  <MdEditSquare color="#0d6efd" size={28} />
                </div>
                <div>
                  <h3 className="modal-title fw-semibold mb-1">Edit Sale</h3>
                  <small className="text-muted fs-5">
                    Update customer, payment method or note. Items cannot be changed.
                  </small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>

            <form onSubmit={handleEditSubmit} className="border-0">
              <div className="modal-body py-3">
                <div className="bg-light rounded-3 px-3 py-3">
                  <div className="row g-3">

                    {/* Sale summary (read-only) */}
                    <div className="col-12">
                      <div className="d-flex gap-3 p-3 bg-white border rounded-3">
                        <div>
                          <p className="text-muted mb-0 fs-4">TOTAL</p>
                          <p className="fw-bold mb-0 fs-4">{editSale?.totalAmount?.toLocaleString()} birr</p>
                        </div>
                        <div>
                          <p className="text-muted mb-0 fs-4">ITEMS</p>
                          <p className="fw-bold mb-0 fs-4">{editSale?.items?.length || 0}</p>
                        </div>
                      </div>
                    </div>

                    {isAdmin && (
                    <div className="col-6">
                            <label className="h4 d-block"> Sell Date</label>
                            <DatePicker
                              selected={editForm.date ? new Date(editForm.date) : null}
                              onChange={(d) => setEditForm(prev => ({ ...prev, date: formatDate(d) }))}
                              className="form-control form-control-lg border-2"
                              placeholderText="Select sell date..."
                            />
                          </div>
                        )}

                    {/* Customer */}
                    <div className="col-12 col-md-6">
                      <label className="fs-4">Customer</label>
                      <Select
                        options={customerOptions}
                        value={editForm.customer}
                        onChange={(v) => setEditForm(prev => ({ ...prev, customer: v || null }))}
                        placeholder="Select customer..."
                        isClearable isSearchable
                        styles={selectStyles}
                      />
                    </div>

                    {!editForm.customer && (
                      <div className="col-12 col-md-6">
                        <label className="fs-4">Customer Name</label>
                        <input
                          className="form-control form-control-lg border-2"
                          placeholder="Walk-in customer name"
                          value={editForm.customerName}
                          onChange={(e) => setEditForm(prev => ({ ...prev, customerName: e.target.value }))}
                        />
                      </div>
                    )}

                    {/* Payment Method */}
                    <div className="col-12 col-md-4">
                      <label className="fs-4">Payment Method</label>
                      <Select
                        options={paymentMethodOptions}
                        value={paymentMethodOptions.find(o => o.value === editForm.paymentMethod)}
                        onChange={(v) => setEditForm(prev => ({ ...prev, paymentMethod: v.value }))}
                        styles={selectStyles}
                      />
                    </div>

                    {/* Paid Amount — only for partial/credit */}
                    {(editForm.paymentMethod === "partial" || editForm.paymentMethod === "credit") && (
                      <div className="col-12 col-md-4">
                        <label className="fs-4">Paid Amount</label>
                        <input
                          className="form-control form-control-lg border-2"
                          type="number" min="0"
                          placeholder="0.00"
                          value={editForm.paidAmount}
                          onChange={(e) => setEditForm(prev => ({ ...prev, paidAmount: e.target.value }))}
                        />
                      </div>
                    )}

                    {/* Note */}
                    <div className="col-12">
                      <label className="fs-4">Note</label>
                      <textarea
                        className="form-control border-2" rows={2}
                        placeholder="Optional note..."
                        value={editForm.note}
                        onChange={(e) => setEditForm(prev => ({ ...prev, note: e.target.value }))}
                      />
                    </div>

                  </div>
                </div>
              </div>

              <div className="modal-footer border-0 pt-0 gap-2">
                <button type="button"
                  className="btn btn-danger border flex-fill rounded-3 fw-medium py-2 fs-2"
                  data-bs-dismiss="modal">Cancel</button>
                <button type="submit"
                  className="btn btn-primary flex-fill rounded-3 fw-medium py-2 fs-2">
                  Update Sale
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>

      {/* ── VOID MODAL ────────────────────────────────────────── */}
      <div className="modal fade" ref={voidModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 rounded-4 shadow-lg p-3">
            <div className="modal-header border-0 pb-0">
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#fde2e2" }}>
                  <MdOutlineCancel color="red" size={34} />
                </div>
                <div>
                  <h5 className="modal-title fw-semibold mb-0 fs-2">Void Sale</h5>
                  <small className="text-muted fs-4">Stock will be restored. This cannot be undone.</small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>
            <div className="modal-body py-3">
              <div className="bg-light rounded-3 px-3 py-3">
                <label className="h4 d-block mb-2">
                  Void Reason <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control border-2" rows={3}
                  placeholder="Enter reason for voiding this sale..."
                  value={voidReason}
                  onChange={(e) => setVoidReason(e.target.value)}
                />
                <small className="text-muted mt-1 d-block fs-4">
                  The sale record will be kept for audit purposes. Stock will be returned.
                </small>
              </div>
            </div>
            <div className="modal-footer border-0 pt-0 gap-2">
              <button className="btn btn-primary border flex-fill rounded-3 fw-medium py-2 fs-2"
                data-bs-dismiss="modal">Cancel</button>
              {isLoading ? (
                <ButtonLoading className="btn btn-danger flex-fill rounded-3 fw-medium py-2 fs-2" disabled>
                  Voiding...
                </ButtonLoading>
              ) : (
                <button className="btn btn-danger flex-fill rounded-3 fw-medium py-2 fs-2"
                  onClick={handleVoidSale}>
                  <MdOutlineCancel size={18} className="me-1" />Void Sale
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ── PAYMENT MODAL ─────────────────────────────────────── */}
      <div className="modal fade" ref={paymentModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 rounded-4 shadow-lg p-3">
            <div className="modal-header pb-3">
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: 48, height: 48, backgroundColor: "#e8f5e9" }}>
                  <MdPayment color="#198754" size={28} />
                </div>
                <div>
                  <h3 className="modal-title fw-semibold mb-1">Record Payment</h3>
                  <small className="text-muted fs-5">
                    Unpaid: {selectedSale?.unpaidAmount?.toLocaleString() || 0} birr
                  </small>
                </div>
              </div>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>
            <form onSubmit={handleAddPayment} className="border-0">
              <div className="modal-body py-3">
                <div className="bg-light rounded-3 px-3 py-3">
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="h4">Amount</label>
                      <input
                        className="form-control form-control-lg border-2"
                        type="number" min="1"
                        placeholder={`Max: ${selectedSale?.unpaidAmount?.toLocaleString() || 0}`}
                        value={paymentData.amount}
                        onChange={(e) => setPaymentData(prev => ({ ...prev, amount: e.target.value }))}
                      />
                    </div>
                    <div className="col-12">
                      <label className="h4">Payment Method</label>
                      <Select
                        options={[{ value: "cash", label: "Cash" }, { value: "bank", label: "Bank" }]}
                        value={{ value: paymentData.paymentMethod, label: paymentData.paymentMethod }}
                        onChange={(v) => setPaymentData(prev => ({ ...prev, paymentMethod: v.value }))}
                        styles={selectStyles}
                      />
                    </div>
                    <div className="col-12">
                      <label className="h4">Note</label>
                      <input
                        className="form-control form-control-lg border-2"
                        placeholder="Optional note..."
                        value={paymentData.note}
                        onChange={(e) => setPaymentData(prev => ({ ...prev, note: e.target.value }))}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0 pt-0 gap-2">
                <button type="button"
                  className="btn btn-danger border flex-fill rounded-3 fw-medium py-2"
                  data-bs-dismiss="modal">Cancel</button>
                {isLoading ? (
                  <ButtonLoading className="btn btn-success flex-fill rounded-3 fw-medium py-2" disabled>
                    Recording...
                  </ButtonLoading>
                ) : (
                  <button type="submit"
                    className="btn btn-success flex-fill rounded-3 fw-medium py-2">
                    Record Payment
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ── RECEIPT MODAL ─────────────────────────────────────── */}
      <div className="modal fade" ref={receiptModalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
          <div className="modal-content border-0 rounded-4 shadow-lg p-3">

            <div className="modal-header border-0 pb-2">
              <h5 className="modal-title fw-semibold">Sale Receipt</h5>
              <button className="btn-close ms-auto" data-bs-dismiss="modal" />
            </div>

            <div className="modal-body py-3">
              {/* Paper size toggle */}
              <div className="d-flex align-items-center gap-3 mb-3 px-2">
                <span className="fw-medium" style={{ fontSize: "0.9rem" }}>Paper size:</span>
                <div className="btn-group btn-group-sm">
                  <button type="button"
                    className={`btn ${receiptSize === "a4" ? "btn-primary" : "btn-outline-primary"} rounded-start-3`}
                    onClick={() => setReceiptSize("a4")}>
                    A4
                  </button>
                  <button type="button"
                    className={`btn ${receiptSize === "thermal" ? "btn-primary" : "btn-outline-primary"} rounded-end-3`}
                    onClick={() => setReceiptSize("thermal")}>
                    Thermal (72mm)
                  </button>
                </div>
              </div>

              {/* Receipt preview */}
              <div className="border rounded-3 bg-white p-2"
                style={{ maxWidth: receiptSize === "thermal" ? "300px" : "100%", margin: "0 auto" }}>
                <ReceiptContent ref={receiptRef} sale={selectedSale} size={receiptSize} />
              </div>
            </div>

            <div className="modal-footer border-0 pt-0 gap-2">
              <button className="btn btn-danger border flex-fill rounded-3 fw-medium py-2"
                data-bs-dismiss="modal">Close</button>
              {/* Separate receiptRef — won't conflict with table print */}
              <ReactToPrint
                trigger={() => (
                  <button type="button"
                    className="btn btn-primary flex-fill rounded-3 fw-medium py-2">
                    🖨️ Print Receipt
                  </button>
                )}
                content={() => receiptRef.current}
                pageStyle={
                  receiptSize === "thermal"
                    ? `@page { size: 72mm auto; margin: 0; } body { margin: 0; }`
                    : `@page { size: A4; margin: 20mm; }`
                }
              />
            </div>

          </div>
        </div>
      </div>

      {/* ── HEADER + BUTTONS ───────────────────────────────────── */}
      <div className="d-flex justify-content-between align-items-center m-4 px-4 py-2 rounded-4 border"
        style={{ backgroundColor: "#faf8f5" }}>
        <h4 className="mb-0 fs-2">Sales</h4>
        <div className="d-flex gap-2 align-items-center flex-wrap">
          <ReactToPrint
            trigger={() => (
              <button className="btn btn-primary rounded-3" onClick={handlePrint}>
                Print Table
              </button>
            )}
            content={() => tablePrintRef.current}
            onAfterPrint={() => setPrintView(false)}
            onBeforeGetContent={handleBeforeGetContent}
            pageStyle="@page { size: A4 landscape; margin: 10mm; }"
          />
          <button className="btn btn-primary rounded-3" onClick={openSaleModal}>
            <AiOutlinePlus className="me-1" /> New Sale
          </button>
        </div>
      </div>

      {/* ── SEARCH + COLUMN TOGGLE (same row, as in Sales1) ───── */}
      <div className="px-4 mb-4">
        <div className="d-flex align-items-center justify-content-between gap-3 px-4 rounded-4 border"
          style={{ backgroundColor: "#faf8f5" }}>
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          <ColumnToggle
            allColumns={allColumns}
            getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          />
        </div>
      </div>

      {/* ── TABLE ─────────────────────────────────────────────── */}
      <div className="px-4" ref={tablePrintRef}>
        {printView && (
          <>
            <div style={{ padding: "1.5rem" }}><h2>Sales</h2></div>
            <div style={{ marginBottom: '1rem', textAlign: "right", fontSize: "1.5rem" }}>
              Date: {new Date().toLocaleDateString()}
            </div>
          </>
        )}
        <div className="table-responsive rounded-4 border mt-5" style={{ backgroundColor: "#ffffff" }}>
          <table className="table table-hover table-striped caption-top fs-4"
            {...getTableProps()}
            style={{ minWidth: "100%", fontSize: "12px", margin: 0 }}>
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th className="px-4" style={{ backgroundColor: "#faf8f5" }}
                      {...column.getHeaderProps()}>
                      {column.render('Header')}
                      {!printView && column.canFilter && column.render('Filter')}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}
                    style={{ opacity: row.original.isVoided ? 0.5 : 1 }}>
                    {row.cells.map(cell => (
                      <td className="px-4" style={{ backgroundColor: "#ffffff" }}
                        {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </td>
                    ))}
                  </tr>
                );
              })}
              {page.length === 0 && (
                <tr>
                  <td colSpan={columns.length} className="text-center text-muted py-4">
                    No sales found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── PAGINATION ────────────────────────────────────────── */}
      <div className="mt-3">
        <ul className="pagination justify-content-center pagination-lg">
          <span style={{ padding: "5px", fontSize: '15px' }}>
            page <strong><em style={{ color: 'blue' }}>{pageIndex + 1}</em> of {pageOptions.length}</strong>
          </span>
          <select className="form-select form-select-lg" style={{ maxWidth: '90px' }}
            value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
            {[10, 15, 20, 30, 40, 50, data.length].map((s, i) => (
              <option key={i} value={s}>Show {s}</option>
            ))}
          </select>
          <li><button className="page-link" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{'<<'}</button></li>
          <li className={`page-item ${!canPreviousPage ? 'disabled' : ''}`}>
            <button className="page-link" onClick={previousPage} disabled={!canPreviousPage}>Previous</button>
          </li>
          <li className={`page-item ${!canNextPage ? 'disabled' : ''}`}>
            <button className="page-link" onClick={nextPage} disabled={!canNextPage}>Next</button>
          </li>
          <li><button className="page-link" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{'>>'}</button></li>
        </ul>
      </div>

    </div>
  );
};
